import React from 'react';
import { useLocation } from 'react-router-dom';
import TrialPage from './trial-page';
import CenteredLayout from '../../components/centered-layout';
import RegistrationForm from './registration-form';
const Registration = () => {
  const location = useLocation();
  const isTrialPage = location?.pathname === '/trial' || location?.pathname === '/endpoint-trial';

  return (
    <>
      {isTrialPage ? (
        <TrialPage />
      ) : (
        <CenteredLayout>
          <RegistrationForm isTrialPage={isTrialPage} />
        </CenteredLayout>
      )}
    </>
  );
};

export default Registration;
